// extracted by mini-css-extract-plugin
module.exports = {"root":"BlogForm_root__bZI8m","formSection":"BlogForm_formSection__ZNe_l"};